import { Star } from "lucide-react";

export default function ReviewBadge({ rating, totalReviews, size = "sm" }) {
  if (!rating && !totalReviews) return null;
  const r = rating || 0;
  const count = totalReviews || 0;
  const isSm = size === "sm";

  return (
    <span className="inline-flex items-center gap-1" data-testid="review-badge">
      <Star className={`${isSm ? "w-3 h-3" : "w-4 h-4"} ${r > 0 ? "fill-[#FACC15] text-[#FACC15]" : "fill-none text-[#CBD5E1]"}`} />
      <span className={`${isSm ? "text-xs" : "text-sm"} font-semibold text-[#0A2540]`}>{r > 0 ? r.toFixed(1) : "-"}</span>
      {count > 0 && <span className={`${isSm ? "text-[10px]" : "text-xs"} text-[#64748B]`}>({count})</span>}
    </span>
  );
}
